import React from "react";
import PropTypes from "prop-types";

import { CoverageItem } from "../../common/CoverageSection/CoverageSection";
import Carousel from "../../Habitacional/Carousel/Carousel";

import useWindowSize from "../../../hooks/useWindowSize";

import * as S from "./FacilitySection.style";

const FacilitySection = ({ title, facilityList }) => {
  const { width } = useWindowSize();
  const isMobile = width && width <= 992;

  const carouselNumberOfSlidersToDisplay = isMobile ? 1 : 2;

  const FacilityItem = Array.isArray(facilityList)
    ? facilityList.map((healthInsuranceItem) => (
        <CoverageItem
          key={healthInsuranceItem.id}
          coverageItem={healthInsuranceItem}
        />
      ))
    : [];

  return (
    <S.FacilitySectionContainer>
      <S.FacilitySectionContent className="container">
        <S.FacilitySectionTitle>{title}</S.FacilitySectionTitle>

        {isMobile ? (
          <Carousel
            numberOfSlidersToDisplay={carouselNumberOfSlidersToDisplay}
            justifyContentOfSlider="flex-start"
          >
            {FacilityItem}
          </Carousel>
        ) : (
          <S.FacilitySectionList>{FacilityItem}</S.FacilitySectionList>
        )}
      </S.FacilitySectionContent>
    </S.FacilitySectionContainer>
  );
};

FacilitySection.propTypes = {
  title: PropTypes.string.isRequired,
  facilityList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      icon: PropTypes.elementType.isRequired,
      title: PropTypes.string,
      description: PropTypes.string,
    })
  ),
};

FacilitySection.defaultProps = {
  facilityList: [],
};

export default FacilitySection;
